export default "__VITE_ASSET__D1guB7rQ__"